import { CommonModule } from '@angular/common';
import {ChangeDetectionStrategy, Component, inject, model, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogModule,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {  FormBuilder, ReactiveFormsModule, Validators, FormGroup } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';

import {MatTabsModule} from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';

import { MatTableModule } from '@angular/material/table';
import { HomeService } from '../../services/home.service';




import { LbnContainerComponent, CheckboxesComponent,LbnInputFieldComponent ,TitleComponent ,LbnAccordianComponent,InputDropdownComponent ,DataPickerComponent ,
  FormActionsButtonsComponent,LbnActionButtonComponent,RadioButtonsComponent} from '../../shared/components';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; 


export interface DialogData {
  animal: string;
  name: string;
}

/**
 * @title Dialog Overview
 */
@Component({
  selector: 'app-add-new-client',
  standalone: true,
  imports: [CommonModule ,MatIconModule,MatDialogModule ,MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule ],
   changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './Add-New-Client.component.html',
  styleUrl: './Add-New-Client.component.scss',
})
export class AddNewClientComponent {
 readonly animal = signal('');
  readonly name = model('');
  readonly dialog = inject(MatDialog);


  openDialog(): void {
    const dialogRef = this.dialog.open(DialogOverviewExampleDialog, {
       width: '700px',
      data: {name: this.name(), animal: this.animal()},
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result !== undefined) {
        this.animal.set(result);
      }
    });
  }
}

@Component({
  selector: 'dialog-overview-example-dialog',
  templateUrl: 'dialog-overview-example-dialog.html',
  styleUrl: 'dialog-overview-example-dialog.scss',
  imports: [
 MatTableModule ,  ReactiveFormsModule,
 LbnContainerComponent, CheckboxesComponent,LbnInputFieldComponent ,TitleComponent ,LbnAccordianComponent,InputDropdownComponent ,DataPickerComponent,
    MatFormFieldModule,MatSelectModule ,MatDatepickerModule,MatNativeDateModule, FormActionsButtonsComponent,LbnActionButtonComponent,RadioButtonsComponent,
    ReactiveFormsModule,MatCardModule,MatTabsModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,MatIconModule,MatDialogModule,CommonModule ,MatButtonModule ,FormsModule,MatInputModule,MatFormFieldModule
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
  
})
export class DialogOverviewExampleDialog {
  readonly dialogRef = inject(MatDialogRef<DialogOverviewExampleDialog>);
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  readonly animal = model(this.data.animal);

  billingForm: FormGroup;
  branches: { name: string }[] = [];
  today = new Date(); // For maxDate on registration date picker

  constructor(private fb: FormBuilder, private homeService: HomeService) {
    // initialize form in constructor to avoid using injected service before initialization
    this.billingForm = this.fb.group({

     activeEmployees: ['', [Validators.required, Validators.pattern('^[0-9]+$'), Validators.min(1), Validators.max(1000000)]],

      clientName: ['', Validators.required],
    
     
    registrationDate: ['', Validators.required],
     branch: ['', Validators.required],
      cmsFinNumber: ['', Validators.required],
   

    });
    this.updateButtonsValues();
    this.loadBranches();
  }

  /**
   * Load branches from API
   */
  private loadBranches(): void {
    this.homeService.getBranches().subscribe({
      next: (response) => {
        // Transform API response to match the dropdown format
        this.branches = response.branches.map(branch => ({ name: branch.name }));
        console.log('✅ Branches loaded:', this.branches);
      },
      error: (error) => {
        console.error('❌ Failed to load branches:', error);
        // Fallback to empty array if API fails
        this.branches = [];
      }
    });
  }
    updateButtons:    {
      label: string,
      position: string,
      action: Function
    }[] = [];

  onNoClick(): void {
    this.dialogRef.close();
  }
   onCategorySelect(value: any) {
    console.log('Selected category:', value);
  }
   updateButtonsValues(){
    this.updateButtons = [
    
 
    {
      label: 'Save',
      position: 'right',
      action: () => this.onSubmit(),
    },
    ]
  }

   onSubmit(): void {
    if (this.billingForm.invalid) {
      this.billingForm.markAllAsTouched();
      return;
    }
  }
}